import React from 'react';
import { Route, Switch, Redirect } from 'react-router';

import AdminPrinters from './components/pages/AdminPrinters';
import AdminUseCounts from './components/pages/AdminUseCounts';
import AdminTenants from './components/pages/AdminTenants';
import AdminUsers from './components/pages/AdminUsers';
import AdminTenant from './components/pages/AdminTenant';
import AdminLocations from './components/pages/AdminLocations';
import AdminProducts from './components/pages/AdminProducts';
import AdminNoSizeProducts from './components/pages/AdminNoSizeProducts';
import AdminNoFnskuLabelInventories from './components/pages/AdminNoFnskuLabelInventories';
import AdminReceivingRequests from './components/pages/AdminReceivingRequests';
import AdminReceivements from './components/pages/AdminReceivements';
import AdminUnknownInventories from './components/pages/AdminUnknownInventories';
import AdminCombiningRequests from './components/pages/AdminCombiningRequests';
import AdminShippingRequests from './components/pages/AdminShippingRequests';
import AdminShippingRequestsPickingList from './components/pages/AdminShippingRequestsPickingList';
import AdminAmazonShippingRequestList from './components/pages/AdminAmazonShippingRequestList';
import AdminCombiningRequestList from './components/pages/AdminCombiningRequestList';
import AdminShippings from './components/pages/AdminShippings';
import AdminCombinings from './components/pages/AdminCombinings';
import AdminPickingItems from './components/pages/AdminPickingItems';
import AdminPickingStats from './components/pages/AdminPickingStats';
import AdminExports from './components/pages/AdminExports';
import AdminSettings from './components/pages/AdminSettings';
import Dashboard from './components/pages/Dashboard';
import UseCounts from './components/pages/UseCounts';
import Products from './components/pages/Products';
import AmazonProducts from './components/pages/AmazonProducts';
import Cases from './components/pages/Cases';
import Sets from './components/pages/Sets';
import ProductMallMappings from './components/pages/ProductMallMappings';
import ReceivingRequests from './components/pages/ReceivingRequests';
import CombiningRequests from './components/pages/CombiningRequests';
import CombiningTemplates from './components/pages/CombiningTemplates';
import ShippingRequests from './components/pages/ShippingRequests';
import MallOrders from './components/pages/MallOrders';
import MallProducts from './components/pages/MallProducts';
import BatchImports from './components/pages/BatchImports';
import Macros from './components/pages/Macros';
import SettingsGeneral from './components/pages/SettingsGeneral';
import SettingsShops from './components/pages/SettingsShops';
import SettingsShop from './components/pages/SettingsShop';
import SettingsSenders from './components/pages/SettingsSenders';
import SettingsDestinations from './components/pages/SettingsDestinations';
import SettingsExtraSellers from './components/pages/SettingsExtraSellers';
import SettingsOtherLocations from './components/pages/SettingsOtherLocations';
import SettingsApiKeys from './components/pages/SettingsApiKeys';
import MypageProfile from './components/pages/MypageProfile';
import StaffPicking from './components/pages/StaffPicking';
import LoginSpApi from './components/pages/LoginSpApi';
import LoginShopify from './components/pages/LoginShopify';

const routeObjs = [
  {
    exact: true,
    path: '/admin',
    component: () => <Redirect to="/admin/useCounts" />,
  },
  {
    exact: true,
    path: '/admin/useCounts',
    component: AdminUseCounts,
  },
  {
    exact: true,
    path: '/admin/printers',
    component: AdminPrinters,
  },
  {
    exact: true,
    path: '/admin/tenants',
    component: AdminTenants,
  },
  {
    exact: true,
    path: '/admin/users',
    component: AdminUsers,
  },
  {
    exact: true,
    path: '/admin/tenants/:tenantId',
    component: AdminTenant,
  },
  {
    exact: true,
    path: '/admin/locations',
    component: AdminLocations,
  },
  {
    exact: true,
    path: '/admin/products',
    component: AdminProducts,
  },
  {
    exact: true,
    path: '/admin/noSizeProducts',
    component: AdminNoSizeProducts,
  },
  {
    exact: true,
    path: '/admin/noFnskuLabelInventories',
    component: AdminNoFnskuLabelInventories,
  },
  {
    exact: true,
    path: '/admin/receivingRequests',
    component: AdminReceivingRequests,
  },
  {
    exact: true,
    path: '/admin/receivements',
    component: AdminReceivements,
  },
  {
    exact: true,
    path: '/admin/unknownInventories',
    component: AdminUnknownInventories,
  },
  {
    exact: true,
    path: '/admin/combiningRequests',
    component: AdminCombiningRequests,
  },
  {
    exact: true,
    path: '/admin/shippingRequests',
    component: AdminShippingRequests,
  },
  {
    exact: true,
    path: '/admin/shippingRequestsPickingList',
    component: AdminShippingRequestsPickingList,
  },
  {
    exact: true,
    path: '/admin/amazonShippingRequestList',
    component: AdminAmazonShippingRequestList,
  },
  {
    exact: true,
    path: '/admin/combiningRequestList',
    component: AdminCombiningRequestList,
  },
  {
    exact: true,
    path: '/admin/shippings',
    component: AdminShippings,
  },
  {
    exact: true,
    path: '/admin/combinings',
    component: AdminCombinings,
  },
  {
    exact: true,
    path: '/admin/pickingItems',
    component: AdminPickingItems,
  },
  {
    exact: true,
    path: '/admin/pickingStats',
    component: AdminPickingStats,
  },
  {
    exact: true,
    path: '/admin/exports',
    component: AdminExports,
  },
  {
    exact: true,
    path: '/admin/settings',
    component: AdminSettings,
  },
  {
    exact: true,
    path: '/',
    component: Dashboard,
  },
  {
    exact: true,
    path: '/useCounts',
    component: UseCounts,
  },
  {
    exact: true,
    path: '/products',
    component: Products,
  },
  {
    exact: true,
    path: '/amazonProducts',
    component: AmazonProducts,
  },
  {
    exact: true,
    path: '/cases',
    component: Cases,
  },
  {
    exact: true,
    path: '/sets',
    component: Sets,
  },
  {
    exact: true,
    path: '/productMallMappings',
    component: ProductMallMappings,
  },
  {
    exact: true,
    path: '/mallProducts',
    component: MallProducts,
  },
  {
    exact: true,
    path: '/receivingRequests',
    component: ReceivingRequests,
  },
  {
    exact: true,
    path: '/combiningRequests',
    component: CombiningRequests,
  },
  {
    exact: true,
    path: '/combiningTemplates',
    component: CombiningTemplates,
  },
  {
    exact: true,
    path: '/shippingRequests',
    component: ShippingRequests,
  },
  {
    exact: true,
    path: '/mallOrders',
    component: MallOrders,
  },
  {
    exact: true,
    path: '/batchImports',
    component: BatchImports,
  },
  {
    exact: true,
    path: '/macros',
    component: Macros,
  },
  {
    exact: true,
    path: '/settings',
    component: () => <Redirect to="/settings/general" />,
  },
  {
    exact: true,
    path: '/settings/general',
    component: SettingsGeneral,
  },
  {
    exact: true,
    path: '/settings/shops',
    component: SettingsShops,
  },
  {
    exact: true,
    path: '/settings/shops/:shopId',
    component: SettingsShop,
  },
  {
    exact: true,
    path: '/settings/senders',
    component: SettingsSenders,
  },
  {
    exact: true,
    path: '/settings/destinations',
    component: SettingsDestinations,
  },
  {
    exact: true,
    path: '/settings/otherLocations',
    component: SettingsOtherLocations,
  },
  {
    exact: true,
    path: '/settings/extraSellers',
    component: SettingsExtraSellers,
  },
  {
    exact: true,
    path: '/settings/apiKeys',
    component: SettingsApiKeys,
  },
  {
    exact: true,
    path: '/mypage/profile',
    component: MypageProfile,
  },
  {
    exact: true,
    path: '/staff/picking',
    component: StaffPicking,
  },
  {
    exact: true,
    path: '/loginSpApi',
    component: LoginSpApi,
  },
  {
    exact: true,
    path: '/loginShopify',
    component: LoginShopify,
  },
]

export default function routes (extraProps) {
  return (
    <Switch>
      {
        routeObjs.map((route, i) => {
          const { exact, path, render, props } = route;
          return (
            <Route exact={exact} path={path} render={render || (_ =>
              <route.component {..._} {...extraProps} {...props} />
            )} key={i} />
          );
        })
      }
    </Switch>
  );
};
